import { createApiSlice } from "@common/common-slice/commonSlice";

import {
  CRUD_SKILL_GROUP,
  GET_SKILL_GROUP,
} from "@routes";

const apiConfig = [
  {
    name: "createSkillGroup",
    method: "post",
    url: CRUD_SKILL_GROUP,
    stateKey: "message",
  },
  {
    name: "getSkillGroup",
    method: "get",
    url: CRUD_SKILL_GROUP,
    stateKey: "data",
  },
  {
    name: "getSkillGroupDetails",
    method: "get",
    url: GET_SKILL_GROUP,
    stateKey: "detailsData",
  },
  {
    name: "updateSkillGroup",
    method: "put",
    url: CRUD_SKILL_GROUP,
    stateKey: "message",
  },
  {
    name: "deleteSkillGroup",
    method: "delete",
    url: CRUD_SKILL_GROUP,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    generate: false,
    backlogLoading: false,
    data: [],
    detailsData: [],
    selectedGroupData: {},
  },

  reducers: {
    skillGroupSelect: (state, action) => {
      state.selectedGroupData = action?.payload;
    },
  },

  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "skillGroup",
  apiConfig,
  customReducers,
);

const skillGroupSlice = slice;

export default skillGroupSlice.reducer;

export const {
  createSkillGroup,
  getSkillGroup,
  getSkillGroupDetails,
  updateSkillGroup,
  deleteSkillGroup,
} = thunks;

export const {
  rowSelect,
  skillGroupSelect,
} = actions;
